export default __webpack_public_path__ + "static/media/personal@3x.300b75f2.png";